<div class="pc-overlay" role="menu">
  @for (item of viewItems(); track item.key) {
  <button
    type="button"
    class="menu-item"
    role="menuitem"
    [class.is-disabled]="item.disabled"
    [attr.aria-disabled]="item.disabled ? 'true' : null"
    [disabled]="item.disabled"
    (click)="onItemClick(item, $event)"
  >
    @if (item.iconClass) { <i [class]="item.iconClass + ' me-2'"></i> } @if
    (item.labelKey) { {{ item.labelKey | translate }} } @else {
    {{ item.label }} }
  </button>
  } @empty {
  <button type="button" class="menu-item is-disabled" disabled>
    <i class="fa fa-info-circle me-2" aria-hidden="true"></i>
    {{ "admin.common.empty" | translate }}
  </button>
  }
</div>
